export default __webpack_public_path__ + "static/media/web.d062829f.mp4";